export { default } from "./FullScreenModal";
